/**
 * Wrapper Material Symbols Outlined.
 *
 * Stack: Material Symbols Outlined come da `.cursor/rules/ui-design-system.mdc`
 * (rule "ICONE"). Usiamo `<span class="material-symbols-outlined">` con
 * size override via classe `!text-[Npx]` per allinearci al CSS Stitch.
 *
 * Nota: `aria-hidden` è il default — quando l'icona ha significato
 * semantico (es. bottone solo icona) il chiamante deve passare un
 * `aria-label` sull'elemento contenitore, NON qui.
 */

import { clsx } from 'clsx';

export type IconSize = 16 | 18 | 20 | 22 | 24 | 28 | 32 | 40 | 48 | 64;

export interface IconProps {
  /** Nome esatto Material Symbols Outlined (es. "dashboard", "calendar_today"). */
  name: string;
  /** Pixel size, default 20 (allineato al rule UI). */
  size?: IconSize;
  className?: string;
  /** Per icone informative dichiara `false` solo se accompagna del testo. */
  ariaHidden?: boolean;
}

export function Icon({
  name,
  size = 20,
  className,
  ariaHidden = true,
}: IconProps) {
  return (
    <span
      className={clsx('material-symbols-outlined leading-none', className)}
      style={{ fontSize: `${size}px` }}
      aria-hidden={ariaHidden}
    >
      {name}
    </span>
  );
}
